var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-icon',{attrs:{"icon":"user","action":_vm.goTo,"title":"ステータス変更"}})}
var staticRenderFns = []

export { render, staticRenderFns }